import { phone_country_codes } from "@/utils/phone_country_codes";
import { HTMLInputTypeAttribute, useEffect, useState } from "react";
import Select from 'react-select';

type TextInputProps = {
  isMandatory?: boolean;
  type?: HTMLInputTypeAttribute;
  pattern?: string;
  minLength?: number;
  maxLength?: number;
  min?: number;
  max?: number;
  labelText?: string;
  inputText?: string | number;
  isDisabled?: boolean;
  theme?: string;
  name?: string;
  setInputText(inputText: string): void;
  setCountryCode?: (code: string) => void;
  countryCode?: string;
};

type Option = {
  value: string;
  label: string;
}

const getValue = (value?: string): Option | null => {
  for (let index = 0; index < phone_country_codes.length; index++) {
    if (phone_country_codes[index].value === value) {
      return phone_country_codes[index];
    }
  }
  return null
}

const customClassNames = {
  control: () => 'text-blueH1 border rounded-l-cornerMob pl-3 select-phone-area',
  // you can also customize other parts like:
  // menu: () => 'your-menu-class',
  // option: () => 'your-option-class',
};

const renderCountryCode = (props: TextInputProps, isMobile: boolean) => {
  if (!props.countryCode || !props.setCountryCode) {
    return null;
  }

  return (
    <div className="select-container">
      <Select
        name={props.name + "CountryCode"}
        value={getValue(props.countryCode)}
        getOptionLabel={(option: Option) => option.label}
        getOptionValue={(option: Option) => option.value}
        options={phone_country_codes}
        onChange={(e) => e?.value && props.setCountryCode!(e?.value)}
        classNames={customClassNames}
        styles={{
          control: (base, state) => ({
            ...base,
            border: '10px',
            borderTopLeftRadius: "1rem",
            borderBottomLeftRadius: "1rem",
            borderTopRightRadius: "0rem",
            borderBottomRightRadius: "0rem",
            fontSize: "1.25rem",
            minHeight: isMobile ? "54px" : "74px",
            height: isMobile ? "unset" : "74px"
          }),
          singleValue: (base, state) => ({
            ...base,
            color: '#041e68',
          }),
        }}
        aria-label="Select country code" />
    </div>
  );
}

const PhoneInput = (props: TextInputProps) => {

  // Check if the user is on a mobile device
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window !== "undefined") {
        setIsMobile(window.innerWidth <= 768);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return (
    <div className="input-container input-container-text flex flex-col h-full">
      <div className="flex items-center w-full">
        {renderCountryCode(props, isMobile)}
        <div className="relative w-full">
          <input
            id={props.labelText}
            name={props.name || props.labelText}
            type={props.type}
            pattern={props.pattern}
            minLength={props.minLength}
            maxLength={props.maxLength}
            min={props.min}
            max={props.max}
            value={props.inputText}
            onChange={(e) => props.setInputText(e.target.value)}
            className={`text-blueH1 border w-full rounded-r-cornerMob text-xl md:text-2xl pl-4 md:pl-6 pr-6 h-full ${props.theme == 'orange' ? 'border-orangeH3 ' : 'border-blueH1 '}`}
            required
            disabled={props.isDisabled}
          />
          {props.labelText && (
            <label
              className={`label ${props.inputText ? 'filled' : ''}`}
              htmlFor={props.labelText}
            >
              {props.labelText + (props.isMandatory ? '*' : '')}
            </label>
          )}
        </div>
      </div>
    </div>
  );
};

export default PhoneInput;
